import * as HYPERCUBEJS from '@hypercubejs/hypercubejs';

import {ScriptCoreTemple} from './coretemple.script.js';

import ambiant from './temple.mp3';

// import ambiant from './Aperture-Tag-OST-28-Central-Hub-_152kbit_Opus_.mp3';
// import ambiant2 from './Fountain Water Bubbling.mp3';

function gameobjectcoretemple() {

    const coretemple = new HYPERCUBEJS.Node('coretemple');
    const meshcoretemple = new HYPERCUBEJS.MeshIcosahedron('meshcoretemple');
    const materialmeshcoretemple = new HYPERCUBEJS.MaterialColor('materialmeshcoretemple', {'color': [0.4, 0.6, 0.8]});

    meshcoretemple.setmaterial(materialmeshcoretemple);
    coretemple.addmesh(meshcoretemple);
    coretemple.setaudio(new Audio(ambiant));
    coretemple.setscript(new ScriptCoreTemple());

    coretemple.setcomponent('collideraabb', {

        'type': 'static',

        'min': [-1, -1, -1],
        'max': [1, 1, 1]
    });

    return coretemple;
}

export {

    gameobjectcoretemple
};

export default gameobjectcoretemple;
